import React from 'react';
import { Download, Trash2 } from 'lucide-react';

interface BulkActionsBarProps {
  selectedCount: number;
  onDownloadAll: () => void;
  onDeleteSelected: () => void;
}

const BulkActionsBar: React.FC<BulkActionsBarProps> = ({
  selectedCount,
  onDownloadAll,
  onDeleteSelected,
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
      <div className="flex items-center justify-between">
        <span className="text-blue-800 dark:text-blue-200">
          {selectedCount} backup{selectedCount > 1 ? 's' : ''} selected
        </span>
        <div className="space-x-2">
          <button
            onClick={onDownloadAll}
            className="px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm"
          >
            <Download className="w-4 h-4 inline mr-1" />
            Download All
          </button>
          <button
            onClick={onDeleteSelected}
            className="px-3 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm"
          >
            <Trash2 className="w-4 h-4 inline mr-1" />
            Delete Selected
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;
